import React, { useEffect, useContext } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { AgendaContext } from '../../contexts/AgendaContext';
// Components
import DetailSkeleton from '../common/DetailSkeleton';
import ConsultorioSkeleton from '../common/ConsultorioSkeleton';
// ErrorProvider
import { useError } from '../../contexts/ErrorProvider.jsx';
//Skeletons
import DashboardSkeleton from '../common/DashboardSkeleton';
import SolicitudDeConexionSkeleton from '../common/SolicitudDeConexionSkeleton.jsx';

function VerifRoute({ loader, setLoader }) {
  const navigate = useNavigate();
  const { getVerifUsuarioAuth, initialize, postRegistrarAcceso } = useContext(AgendaContext);
  const { handleError } = useError();

  useEffect(() => {
    const authController = async () => {
      try {
        await getVerifUsuarioAuth();
        try {
          await initialize();
        } catch (error) {
          handleError({ error: error, description: 'initializeError' });
        }
        await postRegistrarAcceso();
        setLoader(false);
      } catch (error) {
        navigate('/prestador/inicio');
      }
    };

    authController();
  }, []);

  const isDashboardRoute = location.pathname === '/prestador/dashboard';

  const isConsultoriosRoute = location.pathname === '/prestador/misConsultorios';

  const isConsultorioDetailRoute =
    location.pathname.startsWith('/prestador/misConsultorios/') &&
    location.pathname.split('/').length === 4;

  const isSolicitudDetailRoute =
    location.pathname.startsWith('/prestador/solicitud/') &&
    location.pathname.split('/').length === 4;

  const isRegistroRoute = location.pathname === '/prestador/registro';

  if (loader) {
    if (isDashboardRoute) {
      return <DashboardSkeleton />;
    } else if (isConsultoriosRoute) {
      return <ConsultorioSkeleton />;
    } else if (isConsultorioDetailRoute) {
      return <DetailSkeleton />;
    } else if (isSolicitudDetailRoute) {
      return <DetailSkeleton />;
    } else if (isRegistroRoute) {
      return <SolicitudDeConexionSkeleton />
    }
  }

  return <Outlet />;
}

export default VerifRoute;
